




import { Component, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'

@Component

export default class ViewLogin extends Vue {

}
